import React, { useMemo } from 'react';

export function BracketTree({ result }) {
  const data = useMemo(() => {
    const byStage = (counts, top) =>
      result.teams
        .map((team, i) => ({ team, idx: i, p: counts[i] / result.numSimulations }))
        .sort((a, b) => b.p - a.p)
        .slice(0, top);

    return {
      r32: byStage([...result.stageCounts.r32], 8),
      r16: byStage([...result.stageCounts.r16], 8),
      qf:  byStage([...result.stageCounts.qf], 6),
      sf:  byStage([...result.stageCounts.sf], 4),
      final: byStage([...result.stageCounts.final], 3),
      champ: byStage([...result.stageCounts.champion], 1),
    };
  }, [result]);

  const championId = data.champ[0]?.team.id;

  const stages = [
    { key: 'r32',   label: '16es de finale',  rows: data.r32 },
    { key: 'r16',   label: '8es de finale',   rows: data.r16 },
    { key: 'qf',    label: 'Quarts',          rows: data.qf },
    { key: 'sf',    label: 'Demi-finales',    rows: data.sf },
    { key: 'final', label: 'Finale',          rows: data.final },
    { key: 'champ', label: 'Vainqueur',       rows: data.champ },
  ];

  return (
    <div className="card-elev p-5 sm:p-6 mb-8 border border-[#2A4A6B]">
      <header className="mb-6">
        <h3 className="font-heading text-2xl font-bold text-white tracking-tight">
          Projection du Tableau de Phase Finale
        </h3>
        <p className="text-xs text-gray-400 mt-1">
          Les équipes les plus susceptibles d'atteindre chaque étape du tableau à élimination directe.
        </p>
      </header>

      <div className="-mx-4 overflow-x-auto px-4 sm:mx-0 sm:px-0">
        <div className="grid min-w-[900px] grid-cols-6 gap-3">
          {stages.map((stage) => (
            <div key={stage.key} className="flex flex-col">
              <header className="mb-3 text-center font-mono text-[9px] uppercase tracking-wider text-gray-400 font-bold border-b border-[#2A4A6B]/30 pb-1">
                {stage.label}
              </header>
              <div className="space-y-2">
                {stage.rows.map((row) => {
                  const isChampion = stage.key === 'champ';
                  const isChampionPath = row.team.id === championId;
                  return (
                    <div
                      key={row.team.id}
                      className={`relative flex items-center gap-2 rounded-lg border p-2.5 transition-all text-xs ${
                        isChampion
                          ? 'border-[#00C853] bg-gradient-to-r from-[#00C853]/15 to-[#00C853]/5 shadow-[0_4px_15px_rgba(0,200,83,0.15)]'
                          : isChampionPath
                          ? 'border-[#00C853]/30 bg-[#00C853]/5'
                          : 'border-[#2A4A6B]/50 bg-[#1E3A5F]/10 hover:border-[#2A4A6B]'
                      }`}
                    >
                      <img 
                        src={row.team.flag ? (row.team.flag.startsWith('http') ? row.team.flag : `https://flagcdn.com/w80/${row.team.flag.toLowerCase()}.png`) : `https://flagcdn.com/w80/un.png`} 
                        alt="" 
                        className="w-5 h-3.5 object-cover rounded shadow-sm shrink-0" 
                      />
                      <span className={`flex-1 truncate font-semibold text-white ${isChampion ? 'text-sm font-bold text-[#00C853]' : ''}`}>
                        {row.team.name_fr || row.team.name_en || row.team.name}
                      </span>
                      <span className={`font-mono text-[10px] tabular-nums font-bold ${isChampion ? 'text-[#00C853]' : 'text-gray-400'}`}>
                        {(row.p * 100).toFixed(1)}%
                      </span>
                      {isChampion && (
                        <span className="absolute -top-2 left-2 text-xs">
                          🏆
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
